import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

import { NbDialogRef, NbButtonModule, NbIconModule } from '@nebular/theme';
import { TranslatePipe } from '@ngx-translate/core';

import { CommonCardComponent } from '@app/common-modules/common-card/components/common-card/common-card.component';
import { CommonCardBodyComponent } from '@app/common-modules/common-card/components/common-card-body/common-card-body.component';
import { SharedDialog, sharedDialogAnimation } from '../../../../shared/classes/shared-dialog/shared-dialog';




@Component({
  selector: 'slnk-common-pwa-install-dialog',
  templateUrl: './common-pwa-install-dialog.component.html',
  styleUrls: ['./common-pwa-install-dialog.component.scss'],
  animations: [sharedDialogAnimation],
  imports: [CommonCardComponent,
    CommonCardBodyComponent,
    NbButtonModule, NbIconModule, TranslatePipe],
})
export class CommonPwaInstallDialogComponent extends SharedDialog implements OnInit {
  public browser = '';

  @Input() public device: 'ios' | 'android' | 'android-add';

  @Output() public installButtonClicked = new EventEmitter();

  constructor(protected dialogRef: NbDialogRef<CommonPwaInstallDialogComponent>) {
    super(dialogRef, true);
  }

  public ngOnInit(): void {
    this.getBrowser();
  }

  public getBrowser(): void {
    if (navigator.userAgent.indexOf('Safari') !== -1 && navigator.userAgent.indexOf('Chrome') === -1) {
      this.browser = 'Safari';
    } else {
      this.browser = '';
    }
  }
}
